export const isEmptyString = (value?: string | null, trim?: boolean) =>
    value == null || (trim ? value.trim() === "" : value === "");

// For type predicate
export const isNotEmptyString = (
    value?: string | null,
    trim?: boolean
): value is string => !isEmptyString(value, trim);
